import { DialogTitle, Divider, GridProps, useTheme } from '@mui/material';
import { ContextForm, DatePicker, IFormAfterSubmit, InputOnlyField, Text } from '@ngt/forms';
import { ValidateOn } from '@ngt/forms-core';
import { FC, useCallback, useContext } from 'react';
import { Asset } from '../api/dtos';
import { DollarInput, FormSection, IFormDialogProps, StyledButton, StyledDialog, StyledDialogActions, StyledDialogContent, StyledFormColumn, StyledFormSubmitButton } from './inputs/CommonFormElements';
import ReportTemplatePreviewContext from '../contexts/ReportTemplatePreviewContext';
import ReportPreviewContext from '../contexts/ReportPreviewContext';

const COLUMN_SIZING: GridProps['size'] = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
}

const AssetForm: FC<IFormDialogProps> = (props) => {
    const theme = useTheme();
    const { refresh: refreshReportTemplatePreview } = useContext(ReportTemplatePreviewContext);
    const { refresh: refreshReportPreview } = useContext(ReportPreviewContext);

    const onAfterSubmit: IFormAfterSubmit<Asset> = useCallback(async (_newValue, _formState, _formActions) => {
        if(refreshReportTemplatePreview) {
            await refreshReportTemplatePreview();
        }
        if(refreshReportPreview) {
            await refreshReportPreview();
        }
        props.onClose();
    }, [refreshReportTemplatePreview, refreshReportPreview, props.onClose])

    return (
        <ContextForm
            onAfterSubmit={onAfterSubmit}
            validateOn={ValidateOn.onChange}
            validateOnReset
        >
            <StyledDialog {...props}>
                <DialogTitle
                    sx={{
                        backgroundColor: theme.palette.secondary.light,
                        color: "white"
                    }}
                >
                    {props.edit ? "Edit" : "Add"} Asset
                </DialogTitle>
                <StyledDialogContent>
                    <FormSection>
                        <StyledFormColumn
                            size={COLUMN_SIZING}
                        >
                            <InputOnlyField 
                                label="Name"
                                component={Text}
                                propertyPath={'name'}
                            />
                            <InputOnlyField
                                label="Address" 
                                component={Text}
                                propertyPath={'address'}
                            />
                            <DollarInput
                                label="Bank Valuation"
                                propertyPath={'bankValuation'}
                            />
                            <InputOnlyField
                                label="Bank Valuation Date" 
                                component={DatePicker}
                                propertyPath={'bankValuationDate'}
                            />
                            <DollarInput 
                                label="Directors Valuation"
                                propertyPath={'directorsValuation'}
                            />
                            <InputOnlyField
                                label="Directors Valuation Date" 
                                component={DatePicker}
                                propertyPath={'directorsValuationDate'}
                            />
                            <InputOnlyField
                                label="Loan Account ID" 
                                component={Text}
                                propertyPath={'loanAccountId'}                    
                            />
                        </StyledFormColumn>
                    </FormSection>
                </StyledDialogContent>
                <Divider />
                <StyledDialogActions>
                    <StyledFormSubmitButton variant="contained">Submit</StyledFormSubmitButton>
                    <StyledButton variant="contained" onClick={props.onClose}>Cancel</StyledButton>
                </StyledDialogActions>
            </StyledDialog>
        </ContextForm>
    );
}

export default AssetForm;